import { combineReducers } from 'redux';

import app from './app';
import discovery from './discovery';
import quiz from './quiz';
import gamification from './gamification';
import profile from './profile';
import tracker from './tracker';
import interactions from './interactions';
import swiper from './swiper';
import header from './header';
import recycleRight from './recycleRight';
import other from './other';

const rootReducer = combineReducers({
  app,
  discovery,
  quiz,
  gamification,
  profile,
  tracker,
  interactions,
  swiper,
  header,
  recycleRight,
  other
});

export default rootReducer;
